import { FC } from 'react';

import './ImageSkeleton.scss';

const ImageSkeleton: FC = () => {
  return (
    <div className="image-skeleton">
    </div>
  )
}

export default ImageSkeleton;
